<template>
  <div class="checklist">
    <span v-if="!display.smAndDown" class="checklist__title">Клиники</span>
    <CustomCheckbox
      class="checklist__selected-all"
      v-model="isSelected"
      id="Selected All"
    >
      Выбрать все
    </CustomCheckbox>
    <div class="checklist__wrapper">
      <CustomCheckbox
        class="card-clinic"
        v-model="syncSelected"
        v-for="(item, i) in items"
        :key="i"
        :id="i"
        :values="item"
      >
        <div>
          <span class="card-clinic__title">{{ item.name }}</span>
          <div class="card-clinic__street">
            <LocateIcon class="card-clinic__street-icon" />
            <span class="card-clinic__street-title">{{ item.address }}</span>
          </div>
          <div
            v-if="item.subwayStations.length"
            style="display: flex; flex-direction: column; align-items: start"
            class="card-clinic__station"
          >
            <div
              v-for="station in item.subwayStations"
              :key="station.id"
              style="display: flex"
            >
              <div class="card-clinic__station-icon">
                <EllipseIcon :style="{ color: station.color }" />
              </div>
              <span class="card-clinic__station-title">{{
                station.title
              }}</span>
            </div>
          </div>
        </div>
      </CustomCheckbox>
    </div>
    <div class="checklist__buttom">
      <span>Выбрано: {{ syncSelected.length }}</span>
      <Button :disabled="!syncSelected.length" :onClick="applyHandler"
        >Применить</Button
      >
    </div>
  </div>
</template>
<script>
import { computed, ref, toRefs } from '@vue/composition-api'

import CustomCheckbox from './components/customCheckbox'
import Button from '@/components/button'

import LocateIcon from '@/assets/icons/locate'
import EllipseIcon from '@/assets/icons/ellipse'
import { useDisplay } from '@/hooks'

export default {
  name: 'check-list',
  components: {
    Button,
    LocateIcon,
    EllipseIcon,
    CustomCheckbox
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      required: false
    },
    onSubmit: {
      type: Function,
      required: true
    },
    value: {
      type: Array
    }
  },
  computed: {
    syncSelected: {
      get() {
        return this.value ?? []
      },
      set(v) {
        this.$emit('input', v)
      }
    }
  },
  setup(props, ctx) {
    const { items, value } = toRefs(props)
    const isOpen = ref(false)
    const display = useDisplay()

    const isAllSelected = computed(() => {
      if (value.value) {
        return value.value.length === items.value.length
      }
      return false
    })

    const isSelected = computed({
      get() {
        return isAllSelected.value
      },
      set(v) {
        if (v) {
          ctx.emit('input', items.value)
          return
        }

        ctx.emit('input', [])
      }
    })

    const selectedItems = computed(() =>
      items.value.filter((el) => el.selected)
    )

    function handleCheckbox(index) {
      items.value[index].selected = !items.value[index].selected
    }

    function selectedAll() {
      if (isAllSelected.value) {
        items.value.forEach((el) => (el.selected = false))
      } else {
        items.value.forEach((el) => (el.selected = true))
      }
    }

    function applyHandler() {
      isOpen.value = false
      props.onSubmit()
    }

    return {
      isOpen,
      selectedItems,
      handleCheckbox,
      isAllSelected,
      selectedAll,
      applyHandler,
      isSelected,
      display
    }
  }
}
</script>
<style lang="scss" scoped>
@import 'style';
</style>
